<template>
	<div class="row">
		<FsLightbox :toggler="toggler" :slide="slide" :sources="imgs" />
		<hr>
		<div class="col-6 col-md-4 col-lg-3 text-center mb-3" v-for="(item, index) in imgs" :key="index">
			<img :src="item" @click="openLightboxOnSlide(index + 1)" class="img-fluid img-thumbnail" alt="">
		</div>
	</div>
</template>

<script>
import FsLightbox from "fslightbox-vue";
// import FsLightbox from "fslightbox-vue/v2"; for Vue 2

export default {
	components: {
		FsLightbox
	},
	props: {
		imgs: {
			default: []
		}
	},
	methods: {
		openLightboxOnSlide: function (number) {
			this.slide = number;
			this.toggler = !this.toggler;
		}

	},
	data() {
		return {
			toggler: false,
			productIndex: 0,
		}
	}
}
</script>

<style scoped>
.img-thumbnail {
  max-height: 200px;
	cursor: pointer;
}
</style>